import './Header.css';

import { useLocation } from 'react-router-dom';

import InstallButton from './InstallButton';

const navLinks = [
  { href: '/pricing', label: 'Pricing' },
];

const Header = ({ isLoading, isAuthenticated }) => {
  // We need to use window.location.href because we need a full refresh of the page
  // Since we are using backend auth
  const handleLogin = () => {
    window.location.href = '/login';
  };
  const handleLogout = () => {
    window.location.href = '/logout';
  };
  const location = useLocation();

  return (
    <header className="header">
      <div className="header-content">
        <a className="logo" href="/" aria-label="Menu AI home">
          <img src="/favicon.svg" alt="Menu AI" className="logo-icon" />
          <h1 className="logo-text">Menu AI</h1>
        </a>

        <nav className="nav-section">
          {navLinks.map(link => (
            <a
              key={link.href}
              className={`nav-button ${location.pathname === link.href ? 'active' : ''}`}
              href={link.href}
            >
              {link.label}
            </a>
          ))}
          <InstallButton />
        </nav>

        <div className="auth-section">
          {isLoading ? (
            <div>Loading...</div>
          ) : isAuthenticated ? (
            <button onClick={handleLogout} className="auth-button logout-button">
              Logout
            </button>
          ) : (
            <button onClick={handleLogin} className="auth-button login-button">
              Login
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
